import "./styles/personalforum.css"

import { startApp, removeModulePrefix } from "~/startApp"
import Layout from '~/components/personalforum/Layout.vue'
import i18n from '~/utils/i18n'

const defaultModules = removeModulePrefix(import.meta.glob(`../pages/default/**/*.vue`))
const sisaxModules = removeModulePrefix(import.meta.glob(`../pages/sisax/**/*.vue`))
const siteModules = removeModulePrefix(import.meta.glob(`../pages/personalforum/**/*.vue`))

const modules = {
  ...defaultModules,
  ...sisaxModules,
  ...siteModules,
}
startApp(modules, Layout, i18n)


